"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendLoggingEvent = exports.DEFAULT_VALUE = exports.API_HEADERS_CONSTANTS = void 0;
const loggingAPI_1 = require("../API/loggingAPI");
const loggingTypes_1 = require("../types/loggingTypes");
const customDimensionsClass_1 = require("./customDimensionsClass");
const helpers_1 = require("../../../helpers");
const helpersMethod_1 = require("./helpersMethod");
const libs_1 = require("../../../GTMs/libs");
const constants_1 = require("../../../constants");
exports.API_HEADERS_CONSTANTS = {
    RELEASE_VERSION: "9.4.02",
};
exports.DEFAULT_VALUE = "NA";
const sendLoggingEvent = ({ actionNameLvl1, actionNameLvl2, actionNameLvl3, currentScreenName, currentWidgetName, ux_type, referenceEntity, referenceId, memberId, sessionFunnel = true, closePopup, SessionFunnelPointOfEntry, Action_element_name, Action_listing_vas_level, filter_category, filter_subcategory, filter_listing, filter_member, filter_keyword, filter_cp, }) => __awaiter(void 0, void 0, void 0, function* () {
    const logging = customDimensionsClass_1.CustomDimensionsClass.getInstance(currentScreenName);
    const { browserName, browserVersion, deviceBrand, deviceModel, deviceCpuArch, deviceLanguage, deviceOS, deviceOSVersion, deviceTimeZone, } = logging.getDeviceDetails();
    const { connectionType, connectionLatency } = logging.getConnectionInfo();
    const { utmMedium, utmCampaign, utmSource } = logging.getUtms();
    const userAuthentication = referenceId || memberId
        ? loggingTypes_1.EnumUserAuthentication.LOGGED_IN
        : loggingTypes_1.EnumUserAuthentication.LOGGED_OUT;
    const { source, sessionId, trackingId, sessionLife, postCountry } = logging.getSessionDetails();
    const { L1: previousActionLvl1, L2: previousActionLvl2, L3: previousActionLvl3, } = logging.getPreviousActions();
    logging.setSessionFunnelPointOfEntry(SessionFunnelPointOfEntry);
    if (SessionFunnelPointOfEntry) {
        (0, helpers_1.setCookie)(null, constants_1.CookiesConstants.SESSION_FUNNEL_POINT_OF_ENTRY, SessionFunnelPointOfEntry);
    }
    const body = {
        Geo_user_country: "xx",
        Geo_user_city: "NA",
        Geo_user_location: "NA",
        Geo_app_country: postCountry,
        Geo_post_country: exports.DEFAULT_VALUE,
        Geo_post_city: exports.DEFAULT_VALUE,
        Geo_post_neighborhood: exports.DEFAULT_VALUE,
        Geo_post_location: exports.DEFAULT_VALUE,
        Tech_device_brand: deviceBrand,
        Tech_device_model: deviceModel,
        Tech_device_screen_resolution: logging.getScreenResolution(),
        Tech_device_os: deviceOS,
        Tech_device_os_version: deviceOSVersion,
        Tech_device_browser: browserName,
        Tech_device_browser_version: browserVersion,
        Tech_device_language: deviceLanguage,
        Tech_device_timezone: deviceTimeZone,
        Tech_device_user_agent: logging.getDeviceUserAgent(),
        Tech_device_cpu_arch: deviceCpuArch,
        Tech_http_referrer: logging.getHttpReferrer(),
        Tech_app_version: exports.API_HEADERS_CONSTANTS.RELEASE_VERSION,
        Tech_app_language: (0, helpers_1.getLang)() || exports.DEFAULT_VALUE,
        Tech_app_platform: source,
        Tech_app_ui_theme: "light",
        Tech_connection_type: connectionType,
        Tech_connection_latency: connectionLatency,
        User_abbucket: exports.DEFAULT_VALUE,
        User_member_id: memberId || referenceId || exports.DEFAULT_VALUE,
        User_tracking_id: trackingId || exports.DEFAULT_VALUE,
        // @todo fix it replace it from backend
        User_type: exports.DEFAULT_VALUE,
        User_authentication: userAuthentication,
        User_target_id: exports.DEFAULT_VALUE,
        // @todo fix it replace it from backend
        User_target_type: exports.DEFAULT_VALUE,
        Session_id: sessionId,
        Session_search_id: (logging.getClickStreamSearchID() &&
            logging.getClickStreamSearchID() !== "undefined") ||
            undefined ||
            null
            ? logging.getClickStreamSearchID()
            : exports.DEFAULT_VALUE,
        Session_source: utmSource,
        Session_medium: utmMedium,
        Session_campaign: utmCampaign,
        Session_life: sessionLife,
        Session_funnel_source: sessionFunnel
            ? logging.getSessionFunnelSource()
            : loggingTypes_1.EnumLoggingScreenNames.NA,
        Action_screen_name: closePopup
            ? (0, helpersMethod_1.getLastScreenName)(currentScreenName)
            : currentScreenName,
        Action_screen_name_previous: closePopup
            ? currentScreenName
            : (0, helpersMethod_1.getLastScreenName)(currentScreenName),
        Action_widget_name: currentWidgetName || exports.DEFAULT_VALUE,
        Action_ux_type: ux_type || exports.DEFAULT_VALUE,
        Action_name: actionNameLvl1,
        Action_name_lvl2: actionNameLvl2,
        Action_name_lvl3: actionNameLvl3,
        Action_widget_name_previous: logging.getPreviousWidget(),
        Action_name_previous: previousActionLvl1 !== null && previousActionLvl1 !== void 0 ? previousActionLvl1 : exports.DEFAULT_VALUE,
        Action_name_lvl2_previous: previousActionLvl2 !== null && previousActionLvl2 !== void 0 ? previousActionLvl2 : exports.DEFAULT_VALUE,
        Action_name_lvl3_previous: previousActionLvl3 !== null && previousActionLvl3 !== void 0 ? previousActionLvl3 : exports.DEFAULT_VALUE,
        Action_listing_id: exports.DEFAULT_VALUE,
        Action_listing_status: exports.DEFAULT_VALUE,
        Action_listing_category: exports.DEFAULT_VALUE,
        Action_listing_subcategory: exports.DEFAULT_VALUE,
        Action_listing_paid_features: exports.DEFAULT_VALUE,
        Action_listing_cell_type: exports.DEFAULT_VALUE,
        // @todo fix it replace it from backend
        Action_listing_origin_slot_type: exports.DEFAULT_VALUE,
        Action_reference_id: referenceId || exports.DEFAULT_VALUE,
        Action_reference_entity: referenceEntity || exports.DEFAULT_VALUE,
        Action_generated_by: loggingTypes_1.EnumGeneratedBy.USER,
        Session_funnel_point_of_entry: logging.getSessionFunnelPointOfEntry(),
        Action_element_name: Action_element_name ? Action_element_name : exports.DEFAULT_VALUE,
        Action_listing_vas_level: Action_listing_vas_level ? Action_listing_vas_level : "NA",
        filter_category: filter_category ? filter_category : exports.DEFAULT_VALUE,
        filter_subcategory: filter_subcategory ? filter_subcategory : exports.DEFAULT_VALUE,
        filter_listing: filter_listing ? filter_listing : exports.DEFAULT_VALUE,
        filter_member: filter_member ? filter_member : exports.DEFAULT_VALUE,
        filter_keyword: filter_keyword ? filter_keyword : exports.DEFAULT_VALUE,
        filter_cp: filter_cp ? filter_cp : exports.DEFAULT_VALUE,
        Tech_error_code: exports.DEFAULT_VALUE,
        Search_id: exports.DEFAULT_VALUE,
        Search_key: exports.DEFAULT_VALUE,
        Search_page: exports.DEFAULT_VALUE,
        Search_total_results: exports.DEFAULT_VALUE,
        Search_position: exports.DEFAULT_VALUE,
        Search_terms: exports.DEFAULT_VALUE,
    };
    (0, libs_1.trackLoggingEvent)(body);
    logging.setPreviousWidget(currentWidgetName ? currentWidgetName : "NA");
    logging.setPreviousActions({
        L1: actionNameLvl1,
        L2: actionNameLvl2,
        L3: actionNameLvl3,
    });
    yield (0, loggingAPI_1.LoggingAPICall)(body)
        .then(() => {
    })
        .catch((err) => {
        console.log("error ", err);
    });
    return;
});
exports.sendLoggingEvent = sendLoggingEvent;
